<div class="container">
  <div class="content">
    <div class="dialog-headline">
      <h3>Please confirm...</h3>
    </div>
    <div class="box">
      <div class="group">
        <p>
          Are you sure you sure you want to
          <span>{{ action | uppercase }}</span>
          the following file:
        </p>
        <div>
          <p>File Name:</p>
        </div>
        <div>
          <input
            matInput
            readonly
            [value]="logDetails.fileName | fileName" />
        </div>
        <div>
          <p>File Type:</p>
        </div>
        <div>
          <input
            matInput
            readonly
            [value]="logDetails.fileType.displayedName" />
        </div>
        <div>
          <p>
            Datasets
            <strong>passing</strong>
            validation:
          </p>
        </div>
        <div>
          <input
            matInput
            readonly
            [value]="logDetails.stats.changedDatasets - logDetails.stats.invalidDatasets | number: '1.0'" />
        </div>
        <div></div>
        <div>
          <input
            matInput
            readonly
            [value]="
              logDetails.stats.changedDatasets - logDetails.stats.invalidDatasets
                | percentage: logDetails.stats.totalDatasets
            " />
        </div>

        @if (action === actionEnum.Accept) {
          <div></div>
        }
        @if (action === actionEnum.Accept) {
          <div>
            <mat-checkbox [(ngModel)]="publish">Publish to Kafka</mat-checkbox>
          </div>
        }
      </div>

      <mat-divider></mat-divider>
      <form class="form">
        <mat-form-field
          appearance="fill"
          style="width: 96%">
          <mat-label>
            {{
              action === actionEnum.Reject
                ? 'Please provide reason for rejection (mandatory)'
                : 'Please provide a comment (optional)'
            }}
          </mat-label>
          <textarea
            #message
            #txt="ngModel"
            matInput
            cols="90"
            rows="3"
            maxlength="200"
            class="form-control"
            name="message"
            [required]="action === actionEnum.Reject"
            [(ngModel)]="comment"></textarea>
          <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>
        </mat-form-field>
      </form>
      <mat-divider></mat-divider>
      <div class="buttons">
        <coin-v2-button
          [type]="'secondary'"
          [icon]="'close'"
          [iconPos]="'right'"
          [text]="'Cancel'"
          (click)="close()"></coin-v2-button>

        <coin-v2-button
          [type]="'primary'"
          [icon]="'save'"
          [iconPos]="'right'"
          [text]="action"
          [disabled]="txt.invalid || isSubmitting"
          (click)="submit()"></coin-v2-button>
      </div>
    </div>
  </div>
</div>
